import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import articleService from "../services/article-service";

export const articleSearchSchema = z.object({
	search: z.string().optional(),
	status: z.string().optional(),
	authors: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const articlesQueryOptions = (
	search?: z.infer<typeof articleSearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["articles", search],
		queryFn: () =>
			articleService.list(
				transformSearch(search, ["search", "status", "authors"]),
			),
		...options,
	});
};

export const articleQueryOptions = (articleId: string) => {
	return queryOptions({
		queryKey: ["article", articleId],
		queryFn: () => articleService.findById(articleId),
	});
};

export const useArticleCreateMutation = (articleId?: string) => {
	return useMutation({
		mutationKey: ["article", articleId],
		mutationFn: articleService.create,
		meta: {
			successMessage: "Article created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["article"] }),
	});
};

export const useArtticleDeleteMutation = () => {
	return useMutation({
		mutationKey: ["article", "delete"],
		mutationFn: articleService.deleteById,
		meta: {
			successMessage: "Article archived successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["article"],
			});
		},
	});
};

export const useArticleMutation = (articleId?: string) => {
	return useMutation({
		mutationKey: ["article", articleId],
		// mutationFn: articleService.upsert,
		mutationFn: articleService.updateById,
		meta: {
			successMessage: "Article updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["article"] }),
	});
};
